/**
 * Encabezado consistente para páginas del portal administrativo.
 */
export default function AdminPageHeader({ eyebrow, title, description }) {
  return (
    <header className="animate-fade-up">
      {eyebrow && <span className="overline text-accent">{eyebrow}</span>}
      <h1 className="mt-3 font-heading text-3xl sm:text-4xl tracking-tight text-foreground">
        {title}
      </h1>
      {description && (
        <p className="mt-3 text-muted-foreground max-w-2xl leading-relaxed">
          {description}
        </p>
      )}
      <div className="mt-6 divider-gold max-w-[6rem]" />
    </header>
  );
}
